import { getResolveURL } from "../../Scripts/resolveURL";
import { makeSecured2FormDataPostRequest } from "../../../taskpane/wscall-helper";
import { getGlobalconst } from "../../../taskpane/utiltyfunctions";
import { PROPCALLBACKTOKEN, PROPJWTTOKEN, NOTIF_FAIL, ChunkUploadData } from "../../../taskpane/globalconstants";
import { showNotification } from "../../../taskpane/utiltyfunctions";

export async function uploadChunk(file: File, uploadData: ChunkUploadData, chunk: Blob): Promise<any> {
  return new Promise(async (resolve, reject) => {
    // Replace with your application's specific and constant namespace UUID

    try {
      const queryParams: { [key: string]: string } = {};
      const uri = getResolveURL("UPLOADCHUNKS");

      // 1. Create a FormData object
      const formData = new FormData();

      // 2. Append all the metadata fields from @FormDataParam
      formData.append("backupid", uploadData.backupid);
      formData.append("msid", uploadData.msid);
      formData.append("dzUuid", uploadData.dzUuid);
      formData.append("dzChunkIndex", uploadData.dzChunkIndex);
      formData.append("dzTotalFileSize", uploadData.dzTotalFileSize);
      formData.append("dzCurrentChunkSize", uploadData.dzTotalChunkCount);
      formData.append("dzTotalChunkCount", uploadData.dzTotalChunkCount);
      formData.append("dzChunkByteOffset", uploadData.dzChunkByteOffset);
      formData.append("dzChunkSize", uploadData.dzChunkSize);
      formData.append("dzFilename", file.name); // Send the original filename

      // 3. Append the file chunk data
      // The third argument (filename) is important for the server to identify the file.
      // Use the dzFilename provided in the data.
      formData.append("file", chunk, file.name + uploadData.dzChunkIndex);

      const response: any = await makeSecured2FormDataPostRequest(
        getGlobalconst(PROPCALLBACKTOKEN),
        getGlobalconst(PROPJWTTOKEN),
        uri,
        queryParams,
        formData
      );

      if (response.result != "0") {
        reject("HTTP error! status: ${response.status}");
      }

      resolve(response);
    } catch (error) {
      //const myError = "This is the error " + error;
      showNotification(NOTIF_FAIL, "Issue Uploading file, File was aborted " + error);
      reject("Issue Uploading file, File was aborted " + error);
    }
  });
}
